import React from 'react';

const SubContext = React.createContext({
  subs: [],
  selectedSub: null,
  setSelectSub: null,
  userRole: null,
});

export default SubContext;
